/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceResourceDetails {
    getFixupPrototypeFunction() { return ServiceResourceDetails.fixupPrototype; }

    static newInstance(model: Partial<ServiceResourceDetails>): ServiceResourceDetails {
        let obj = Object.assign(new ServiceResourceDetails(), model);
        ServiceResourceDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceResourceDetails>): ServiceResourceDetails {
        if (!model) return null;
        return ServiceResourceDetails.newInstance(<ServiceResourceDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceResourceDetails) {
        if (!obj) return;

        models.ServiceResourceDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceResourceDetails): boolean {
        Object.setPrototypeOf(obj, ServiceResourceDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.created_at === "string") {
            this.created_at = new Date(<string><any>this.created_at);
        }
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.tags) {
            for (let val of this.tags) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Unique ID of the resource element
     */
    check_resource_element: string;

    /**
     * Operation ID for resource discovery
     */
    operation_id: string;

    /**
     * Resource filter criteria used
     */
    resource_filter: string;

    /**
     * Service account ID
     */
    service_account_id: string;

    /**
     * Name of the cloud account
     */
    service_account_name: string;

    /**
     * Resource category
     */
    category: string;

    /**
     * Resource component
     */
    component: string;

    /**
     * Creation timestamp
     */
    created_at: Date;

    /**
     * Resource region/location/zone
     */
    location: string;

    /**
     * Resources of the cloud provider
     */
    resource: string;

    /**
     * Type of the resource
     */
    resource_type: string;

    /**
     * Detailed resource information from cloud provider
     */
    summary_details: any;

    /**
     * Resource tags as key-value pairs
     */
    tags: Array<models.KeyValuePair>;

    /**
     * Extended provider-native attributes for this resource, populated for resource types that need more than summary_details carries
     */
    extended_summary_details: any;

    /**
     * Last update timestamp
     */
    updated_at: Date;

}
